import request from '../utils/request';

export interface Notice {
  id: number;
  type: number; // 1-滚动公告 2-固定公告
  content: string;
  status: number; // 0-禁用 1-启用
  admin_id: number;
  addtime: number;
  updatetime: number;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data?: T;
}

export interface NoticeListResponse {
  list: Notice[];
  total: number;
}

// 获取公告列表
export const getNotices = async (): Promise<ApiResponse<NoticeListResponse>> => {
  return request.get('/notices');
};

// 更新公告
export const updateNotice = async (type: number, content: string): Promise<ApiResponse<null>> => {
  return request.put('/notices', { type, content });
};

// 更新公告状态
export const updateNoticeStatus = async (type: number, status: number): Promise<ApiResponse<null>> => {
  return request.put('/notices/status', { type, status });
}; 